/* eslint-disable import/prefer-default-export */
export const BYTES_IN_KIB = 1024;



// WEBPACK FOOTER //
// ./lib/utils/constants.js